let savedLeft = null;

document.addEventListener('click', (event) => {
  if (event.target.matches('.product-personalizer button')) {
    // STEP 1
    const target = document.querySelector('.pplr-choose-your-champagne');
    const mainContent = document.querySelector('.pplr-p-right')
    if (!target) return;

    document.querySelector('.js-modal-close.pplr_close.p_r_c').addEventListener('click', () => {
      window.location.href = window.location.href.split('?')[0] + '?nocache=' + Date.now();
    })

    // const checkStep2 = setInterval(() => {
    //   const el = document.querySelector('.pplr-grouped-wrapper-step-go-to-gift');

    //   if (el && !el.classList.contains('hidden')) {
    //     clearInterval(checkStep2);
    //     mainContent.scrollTo({
    //       top: document.querySelector('.pplr-grouped-wrapper-step-go-to-gift').offsetTop,
    //       behavior: "smooth"
    //     });
    //   }
    // }, 500);

    const interval = setInterval(() => {
      const line1 = document.querySelector('.pplr-wrapper.pplr-text.pplr-line-1');
      const line2 = document.querySelector('.pplr-wrapper.pplr-text.pplr-line-2');
      const buttonToGiftCard = document.querySelector('.pplr-next-step-to-gift-card');
      const left = document.querySelector('.pplr-p-left');

      if (line1 && line2 && buttonToGiftCard && left) {
        clearInterval(interval);

        // Always update savedLeft if found
        if (left) savedLeft = left;

        // Create wrapper if not exists
        let wrapperDiv = document.querySelector('.pplr-grouped-wrapper-step-go-to-gift');
        if (!wrapperDiv) {
          wrapperDiv = document.createElement('div');
          wrapperDiv.className = 'pplr-grouped-wrapper-step-go-to-gift hidden';

          const wrapperDivForText = document.createElement('div');
          [line1, line2, buttonToGiftCard].forEach(el => wrapperDivForText.appendChild(el));
          wrapperDivForText.className = 'pplr-grouped-step-line-text';
          wrapperDiv.appendChild(wrapperDivForText);

          target.insertAdjacentElement('afterend', wrapperDiv);

          // Heading
          const pplrLabelLine = document.querySelector('.pplr-choose-your-champagne .pplrlabel');
          if (pplrLabelLine) {
            const clonedLabel = pplrLabelLine.cloneNode(true);
            clonedLabel.innerHTML = 'PERSONALISE YOUR BOTTLE';
            clonedLabel.classList.add('pplr-grouped-wrapper-step-go-to-gift--heading');
            wrapperDiv.appendChild(clonedLabel);
          }
        }

        // Ensure .pplr-p-left is appended correctly
        const currentLeft = document.querySelector('.pplr-p-left.pplr');
        if (currentLeft && !wrapperDiv.contains(currentLeft)) {
          wrapperDiv.appendChild(currentLeft);
        } else if (savedLeft && !wrapperDiv.contains(savedLeft)) {
          wrapperDiv.appendChild(savedLeft);
        }

        // Watch visibility
        const watchDisplay = setInterval(() => {
          const isHidden =
            getComputedStyle(line1).display === 'none' &&
            getComputedStyle(line2).display === 'none' &&
            getComputedStyle(buttonToGiftCard).display === 'none';

          if (isHidden) {
            if (savedLeft) savedLeft.style.display = 'none';
          } else {
            wrapperDiv.classList.remove('hidden');
            if (savedLeft) savedLeft.style.display = '';
            clearInterval(watchDisplay);
          }
        }, 300);
      }
    }, 200);

    document.querySelector('.pplr-next-step-to-gift-card').classList.add('not-allow');
    const checkInputsLine = setInterval(() => {
      const fields = document.querySelectorAll('.pplr-grouped-step-line-text .pplr-text input');

      let allFilled = true;
      fields.forEach(field => {
        if (field.value === '') {
          allFilled = false;
        }
      });

      if (allFilled) {
        clearInterval(checkInputsLine);

        if (document.querySelector('.pplr-next-step-to-gift-card')) document.querySelector('.pplr-next-step-to-gift-card').classList.remove('not-allow'); 
      }
    }, 500);

    document.querySelector('.pplr-next-step-to-gift-card').addEventListener('click', () => {
      mainContent.scrollTo({
        top: document.querySelector('.pplr-choose-your-gift-card').offsetTop,
        behavior: "smooth"
      });
    })

    // STEP 2
    const line1Input = document.querySelector('.pplr-wrapper.pplr-text.pplr-line-1 input');
    const line2Input = document.querySelector('.pplr-wrapper.pplr-text.pplr-line-2 input');
    const line1Value = line1Input ? line1Input.value : '';
    const line2Value = line2Input ? line2Input.value : '';

    const wrapper = document.createElement('div');
    const mergeMessagesHeader = document.createElement('div');
    const mergeMessagesGroup = document.createElement('div');
    const mergeMessagesImage = document.createElement('img');

    wrapper.className = 'pplr-merged-message-group';
    wrapper.append(mergeMessagesHeader);
    wrapper.append(mergeMessagesImage);
    wrapper.append(mergeMessagesGroup);
    wrapper.style.display = 'none';

    mergeMessagesHeader.className = 'pplr-merged-message-header';
    mergeMessagesHeader.innerHTML = 'WRITE YOUR MESSAGE';

    mergeMessagesGroup.className = 'pplr-merged-message-list';

    mergeMessagesImage.className = 'pplr-merged-message-image';
    mergeMessagesImage.src = 'https://cdn.shopify.com/s/files/1/0656/6061/6938/files/Step_4_1_1.png?v=1762227402';

    const wrapperExisting = document.querySelector('.pplr-grouped-wrapper-step-go-to-gift');

    const mergeMessages = Array.from(document.querySelectorAll('*')).filter(el =>
      Array.from(el.classList).some(cls => /^pplr-.+-merge-message$/.test(cls)) &&
      !wrapperExisting?.contains(el)
    );

    mergeMessages.forEach(el => mergeMessagesGroup.appendChild(el));

    // Safe append to avoid null
    const nextStepGiftTag = document.querySelector('.pplr-next-step-to-gift-tag');
    if (nextStepGiftTag) mergeMessagesGroup.appendChild(nextStepGiftTag);

    const giftCardEl = document.querySelector('.pplr-choose-your-gift-card');
    if (giftCardEl && giftCardEl.parentNode) {
      giftCardEl.parentNode.insertBefore(wrapper, giftCardEl.nextSibling);
    } else {
      const targethtml = document.querySelector('#pplr_html');
      if (targethtml) targethtml.appendChild(wrapper);
    }

    // Watch merged message visibility
    const watchDisplayMessage = setInterval(() => {
      if (!mergeMessages.length) return;

      const allHidden = mergeMessages.every(
        el => getComputedStyle(el).display === 'none'
      );

      if (allHidden) {
        mergeMessagesHeader.style.display = 'none';
      } else {
        mergeMessagesHeader.style.display = '';
        wrapper.style.display = '';
        clearInterval(watchDisplayMessage);
        mainContent.scrollTo({
          top: wrapper.offsetTop,
          behavior: "smooth"
        });
      }
    }, 300);

    // Cleanup label text
    const allMessageMerge = document.querySelectorAll('.pplr-merged-message-group .pplrlabel');
    allMessageMerge.forEach((item) => {
      item.innerText = item.innerText.replace('(Merge Message)', '').trim();
    });

    document.querySelector('.pplr-next-step-to-gift-tag').addEventListener('click', () => {
      mainContent.scrollTo({
        top: document.querySelector('.pplr-choose-your-gift-tag').offsetTop,
        behavior: "smooth"
      });
    })
    
    nextStepGiftTag.classList.add('not-allow');
    const checkInputs = setInterval(() => {
      const fields = document.querySelectorAll('.pplr-merged-message-group .pplr-text input, .pplr-merged-message-group .pplr-text textarea');

      let allFilled = true;
      fields.forEach(field => {
        if (field.value === '') {
          allFilled = false;
        }
      });

      if (allFilled) {
        clearInterval(checkInputs);

        console.log('All inputs are filled!');
        nextStepGiftTag.classList.remove('not-allow'); 
      }
    }, 500);

    const checkStep5 = setInterval(() => {
      const el = document.querySelector('.pplr-choose-your-ribbon');

      if (el && el.style.display !== 'none') {
        clearInterval(checkStep5);
        mainContent.scrollTo({
          top: document.querySelector('.pplr-choose-your-ribbon').offsetTop,
          behavior: "smooth"
        });
      }
    })
  }
});
